import address from '../images/address-icons/address.svg';
import { colors } from '../../colors/colors';

export const geoPointLocationIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    defaultSymbol: {
        // used when item field dont match anything defined in uniqueValueInfos
        type: 'simple-marker',
        style: 'triangle',
        color: colors.mapLocationPin,
        size: '32px',
    },
    uniqueValueInfos: [
        {
            value: 'Inactive',
            symbol: {
                type: 'picture-marker',
                url: address,
                width: '32px',
                height: '32px',
            },
        },
        {
            value: 'Selected',
            symbol: {
                type: 'picture-marker',
                url: address,
                width: '32px',
                height: '32px',
            },
        },
    ],
    authoringInfo: undefined,
};
